import { render } from "./Collapsible.vue?vue&type=template&id=048bc23c"
import script from "./Collapsible.vue?vue&type=script&lang=js"
export * from "./Collapsible.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__